<template lang="pug">
  div
    .row.bcard-card-details-cardinfo-wrap(data-testid="-content-card")
      .col-xs-6
        //- 読み取りエラー(画像解析失敗、読取不能、一部読取不能)
        .alert.alert-warning(v-if="isImageError(bcard)")
          p
            i.fa.fa-warning
            | &nbsp;名刺画像の読み取りができませんでした。
          p 名刺情報の変更を行うか、名刺画像が不鮮明な場合には改めて名刺登録を行ってください。
          p ※名刺情報の変更は名刺交換者のみ可能です。
        //- 入力待ち状態
        .alert.alert-info(v-if="isImageProxing(bcard)")
          i.fa.fa-info-circle
          | &nbsp;修正サービス依頼中のため、修正完了後に名刺情報が上書きされます。
        .bcard-card-details-cardinfo
          .bcard-card-details-card-info-name-office
            latest-label(:is-latest="bcard.is_latest")
            h4(data-testid="-full-name") {{bcard.full_name}}
            p.text-muted(data-testid="-full-kana") {{bcard.full_kana}}
            h4(data-testid="-corporate-name") {{bcard.corporate_name}}
            p.text-muted(data-testid="-corporate-kana") {{bcard.corporate_kana}}
            h4(data-testid="-company-name") {{bcard.company_name}}
            p.text-muted(data-testid="-company-kana") {{bcard.company_kana}}
            p.bcard-card-details-group(data-testid="-dept") {{bcard.dept}}
            p.bcard-card-details-post(data-testid="-post") {{bcard.post}}
            p.bcard-card-details-group-post(data-testid="-dept-post") {{bcard.dept_post}}

      //- 主に名刺画像
      .col-xs-6.bcard-card-details-img-block
        .bcard-card-details-img-block-top
          //.bcard-btnbar.text-right(v-if="isCardEditable")
            a.btn.btn-primary.btn-sm(@click.prevent="showModCardModal(latestBcard.id)" title="変更", data-testid="-btn-edit")
              i.fa.fa-edit
          .text-center
            a(v-if="bcard.image_url && bcard.image_url.length !== 0" href="#" @click.prevent="showCardImageModal(bcard.id)")
              img.bcard-card-details-card-img(:src="app_imgsrc.now_loading" v-src="bcard.image_url", :alt="bcard.image_name", data-testId="-files")
            file-droppable(v-else-if="bcard.images && bcard.images.length", v-model="bcard.images", :multi="true", :view_mode="true", :main-image-id="bcard.image_id")
            img.bcard-card-details-card-img(v-else :src="app_imgsrc.now_loading" v-src="bcard.image_url" data-testId="-files")

    //- 事務所
    card-office-view(:bcard="bcard")

    portal(to="popup")
      modal-images(v-model="modalImages")
</template>

<script>
import FileDroppable from '@/components/organisms/FileDroppable'
import CardOfficeView from './CardOfficeView'
import ModalImages from '@/components/organisms/ModalImages'
import LatestLabel from '@/components/molecules/LatestLabel'

export default {
  name: 'CardView',
  components: {
    FileDroppable,
    CardOfficeView,
    ModalImages,
    LatestLabel
  },
  props: {
    bcard: { type: Object, required: true }
  },
  data () {
    return {
      modalImages: {
        isOpen: false,
        sid_bcard: null
      }
    }
  },
  methods: {
    // 画像読み取りエラーを返す
    isImageError (item) {
      return item.imageError === this.app_flag.ON
    },
    // 画像代行入力中かどうかを返す
    isImageProxing (item) {
      return item.isProxing === this.app_flag.ON
    },
    // 名刺の画像ダイアログ表示
    showCardImageModal (sid_bcard) {
      this.modalImages.isOpen = true
      this.modalImages.sid_bcard = sid_bcard
    }
  }
}
</script>

<style lang="scss" scoped>
  .bcard-card-details-img-block-top {
    margin-bottom: 15px;
  }

  .bcard-card-details-card-img {
    max-width: 100%;
    max-height: 300px;
  }
</style>



// WEBPACK FOOTER //
// src/components/organisms/views/CardView.vue